import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { proxyCall } from "./proxy";
import { isValidSlug } from "./slug";
import { useSession } from "./session";
import { parseStored } from "./persist";
import { orgName } from "./engagement";
import { T } from "./theme";
import ClientView from "./client/ClientView";
import normalizeConfig from "./finance/normalizeConfig";
import validateConfig from "./finance/validateConfig";
import { getCurrentMonth } from "./finance/calc";

// The client's page: load the engagement, show the read-only view. Every
// edit Thread makes happens in the admin workspace (/admin/:slug).
export default function EngagementPage() {
  const { slug } = useParams();
  const [engagement, setEngagement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  // Signed in before this page renders (App's SessionGate). Which engagement
  // this person may open is decided server-side, never by the slug alone.
  const { signOut } = useSession();
  const [steps, setSteps] = useState({});
  const [cfg, setCfg] = useState(() => normalizeConfig(null));
  const [configProblems, setConfigProblems] = useState([]);
  const [data, setData] = useState({ months: {}, upcoming: [], extras: [], sessions: [], history: [] });

  useEffect(() => { loadEngagement(); }, [slug]);

  const loadEngagement = async () => {
    setLoading(true);
    if (!isValidSlug(slug)) { setNotFound(true); setLoading(false); return; }
    try {
      // Another engagement's slug is refused server-side (403); shown as not found.
      const c = await proxyCall({ action: "engagement", slug });
      if (!c || !c.id) { setNotFound(true); setLoading(false); return; }
      setEngagement(c);
      const stored = parseStored(c.fields);
      if (stored.steps) setSteps(stored.steps);
      if (stored.config) { setCfg(normalizeConfig(stored.config)); setConfigProblems(validateConfig(stored.config)); }
      const fd = stored.data || {};
      setData({ months: fd.months || {}, upcoming: fd.upcoming || [], extras: Array.isArray(fd.extras) ? fd.extras : [], sessions: fd.sessionBlock?.sessions || [], history: fd.sessionBlock?.history || [] });
    } catch (e) { console.error(e); setNotFound(true); }
    setLoading(false);
  };


  if (loading) return (<div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: T.bgSurface, fontFamily: T.fontSans }}><p style={{ color: T.fgMuted, fontSize: 14 }}>Loading...</p></div>);
  if (notFound) return (<div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 12, background: T.bgSurface, fontFamily: T.fontSans }}><h2 style={{ fontSize: 20, fontWeight: 700, color: T.root }}>Page not found</h2><p style={{ color: T.fgMuted, fontSize: 14 }}>Check the URL and try again.</p></div>);

  const f = engagement.fields;
  const company = orgName(f);

  return (
    <div style={{ minHeight: "100vh", background: T.bgSurface, fontFamily: T.fontSans }}>
      <div className="hub-header" style={{ background: T.bgInverse, padding: "12px 40px" }}>
        <div className="hub-header-inner" style={{ maxWidth: 840, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 16 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14, minWidth: 0 }}>
            {f["Logo URL"] && (<div style={{ width: 96, height: 32, display: "flex", alignItems: "center", flex: "none" }}><img src={f["Logo URL"]} alt="" style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }} /></div>)}
            <div style={{ minWidth: 0 }}>
              <div style={{ color: T.canopy, fontSize: 10, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase" }}>Client portal</div>
              <h1 style={{ color: T.fgOnDark, fontSize: 16, fontWeight: 700, margin: 0, lineHeight: 1.3 }}>{company}</h1>
            </div>
          </div>
          <button onClick={signOut} style={{ fontSize: 12, color: T.canopy, background: "none", border: "none", padding: 0, cursor: "pointer", fontFamily: T.fontSans }}>Sign out</button>
        </div>
      </div>
      <div>
        <ClientView
          fields={f} cfg={cfg} configProblems={configProblems} steps={steps}
          finance={data.months} upcoming={data.upcoming} extras={data.extras} blockSessions={data.sessions} blockHistory={data.history}
          currentMonth={getCurrentMonth()}
        />
      </div>
    </div>
  );
}
